// Add polyfills that are not covered by babel polyfill.

// DOM polyfill for element.closest (required by IE 11).
import 'element-closest-polyfill';
